/**
 * Session ID management using sessionStorage.
 * - New UUID generated on first access in a browser session
 * - Persists during navigation (same tab/window)
 * - Resets when browser closes
 */

const SESSION_STORAGE_KEY = 'myma_session_id';

export const getOrCreateSessionId = () => {
  let sessionId = sessionStorage.getItem(SESSION_STORAGE_KEY);
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem(SESSION_STORAGE_KEY, sessionId);
  }
  return sessionId;
};

export const clearSessionId = () => {
  sessionStorage.removeItem(SESSION_STORAGE_KEY);
};
